import {Fragment} from "react";
import {IconButton} from "@mui/material";
import {Box} from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import RemoveCustomFieldModal from "./RemoveCustomFieldModal";
import useModalSetup from "../../../../../hooks/useModalSetup";

export default function RemoveCustomFieldEntry({customFieldId, selectedCustomField, loading}) {
    const {handleOpenModal, handleCloseModal, openModal} = useModalSetup();
    const {id} = selectedCustomField;
    const isProcessing = customFieldId === id && loading;

    return (
        <Fragment>
            {
                isProcessing ?
                    <Box sx={style.progressIconContainer}>
                        <CircularProgress size={15} sx={style.icon}/>
                    </Box> :
                    <IconButton sx={{mr: '-8px'}} onClick={handleOpenModal} disabled={loading}>
                        <DeleteIcon sx={style.deleteIcon}/>
                    </IconButton>
            }
            <RemoveCustomFieldModal
                title={'Delete custom field'}
                open={openModal}
                handleClose={handleCloseModal}
                customFieldId={customFieldId}
            />
        </Fragment>
    )
}

const style = {
    deleteIcon: {
        color: '#AC2925',
        fontSize: '22px',
        textAlign: 'right'
    },
    icon: {
        color:'#003300',
    },
    progressIconContainer: {
        width: '25px',
        height: '25px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
}